import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "children"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../hooks/useMapTokenPropsToCSS';
import { VIEW_RESET_STYLES } from './View.styles';
import { deepMerge } from '../../transitional/utils/deepMerge/deepMerge';
import { useBadgeContext } from '../../transitional/components/Badge/BadgeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledView = styled.div.withConfig({
  displayName: "View__StyledView",
  componentId: "sc-1fwawxt-0"
})(props => {
  const $cssStyles = props.$cssStyles;
  const $styleOverrides = props.$styleOverrides;
  return deepMerge(Object.assign({}, VIEW_RESET_STYLES, $cssStyles), $styleOverrides !== null && $styleOverrides !== void 0 ? $styleOverrides : {});
});

/**
 * `View` is a primitive layout component that provides access to the
 * style props defined in the design system alongside many of our
 * token values.
 *
 * `View` does not handle flex or grid layouts. Use the `Flex` and `Grid`
 * components for those.
 */
export const View = _ref => {
  let {
      as = 'div',
      children
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps,
    callbackProps
  } = filterProps(restProps);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const badgeContext = useBadgeContext();
  return /*#__PURE__*/_jsx(StyledView, Object.assign({}, domProps, callbackProps, {
    as: as,
    $cssStyles: cssStyles,
    $styleOverrides: badgeContext === null || badgeContext === void 0 ? void 0 : badgeContext.badgeStyleOverrides,
    children: children
  }));
};